import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as VmsState from '../../backend/index-vms-state';

import { VisitorInsightsTopBar, PowerBiDashboardView } from '../../components';
import s from './VisitorInsights.module.scss';

class VisitorInsights extends Component {
    static propTypes = {
        loading: PropTypes.bool.isRequired,
        powerBIReportConfig: PropTypes.object.isRequired,
        configs: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    onChangeReportConfig = configId => {
        const { dispatch } = this.props;
        dispatch(VmsState.SessionReducer.Actions.setInsightsReport(configId));
    };

    render() {
        const { loading, powerBIReportConfig, configs } = this.props;

        const topBarProps = () => ({
            configName: powerBIReportConfig.name,
            configId: powerBIReportConfig.id,
            configs,
            onConfigSelect: this.onChangeReportConfig,
        });

        return (
            <div className={s.analytics}>
                <VisitorInsightsTopBar {...topBarProps()} />
                <PowerBiDashboardView powerBIReportConfig={powerBIReportConfig} loading={loading} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const configs = VmsState.SessionReducer.Selectors.getInsightsConfigs(state) || [];
    const config = VmsState.SessionReducer.Selectors.getInsightsConfig(state) || {};
    return {
        configs,
        loading: false,
        powerBIReportConfig: config,
    };
};

export default connect(mapStateToProps)(VisitorInsights);
